import React, {ReactElement} from 'react';
import Grid from '@mui/material/Grid';

import AnalyticsTotalCard, {
  AnalyticsTotalCardProps
} from '../AnalyticsTotalCard';
import {StoreAnalyticsDataType} from '../../api/storesApi';

export type AnalyticsTotalsProps = {
  data: StoreAnalyticsDataType;
  loading?: boolean;
};

type cardDataType = {
  shouldHide?: boolean;
  data: AnalyticsTotalCardProps;
};

const AnalyticsTotals = ({
  data,
  loading
}: AnalyticsTotalsProps): ReactElement => {
  const {totals, previousTotals} = data;
  const topColors = [
    'rgb(30, 57, 210)',
    'rgb(92, 207, 194)',
    'rgb(250, 60, 0)',
    'rgb(166, 57, 178)'
  ];
  const cardDataArray: Array<cardDataType> = [
    {
      data: {
        title: 'Sales',
        current: totals?.netSales,
        previous: previousTotals?.netSales,
        format: '$0,0',
        tooltipText:
          'When applicable, this number includes product, shipping, and tax amounts'
      }
    },
    {
      shouldHide: totals?.profits == null,
      data: {
        title: 'Estimated profits',
        current: totals?.profits,
        previous: previousTotals?.profits,
        format: '$0,0'
      }
    },
    {
      shouldHide: totals?.voucherTotal == null,
      data: {
        title: 'Vouchers redeemed',
        current: totals?.voucherTotal,
        previous: previousTotals?.voucherTotal,
        format: '$0,0',
        tooltipText:
          'When applicable, this number includes product, shipping, and tax amounts'
      }
    },
    {
      data: {
        title: 'Orders',
        current: totals?.salesQty,
        previous: previousTotals?.salesQty,
        format: '0,0'
      }
    },
    {
      data: {
        title: 'Items sold',
        current: totals?.itemsTotal,
        previous: previousTotals?.itemsTotal,
        format: '0,0'
      }
    }
  ];

  const visibleCardDataArray = cardDataArray.filter(
    cardData => !cardData.shouldHide
  );

  const numCol = visibleCardDataArray.length;

  return (
    <div className="admin-StoreAnalytics-totals">
      <Grid container spacing={2} className="productRow">
        {visibleCardDataArray.map(
          (cardData: cardDataType, index: number): ReactElement => {
            return (
              <Grid
                item
                className="productCol"
                key={cardData.data.title}
                lg={12 / numCol}
                md={12 / numCol}
                sm={6}
                xs={12}>
                <AnalyticsTotalCard
                  {...cardData.data}
                  loading={loading}
                  topColor={topColors[index % 4]}
                />
              </Grid>
            );
          }
        )}
      </Grid>
    </div>
  );
};

AnalyticsTotals.defaultProps = {
  loading: false
};

export default AnalyticsTotals;
